import { getOWAConnectedAccount } from 'owa-accounts-store';

export function getEmailAddressForSetTimeProfileService(
    mergedViewEnabledAccountSmtpAddress: string
): string {
    let consumerEmailAddress;
    const account = getOWAConnectedAccount(mergedViewEnabledAccountSmtpAddress);
    if (account && account.accountProviderType == 'Google') {
        consumerEmailAddress = account.anchorMailbox;
    } else {
        consumerEmailAddress = mergedViewEnabledAccountSmtpAddress;
    }

    return consumerEmailAddress;
}
